import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const CATEGORIAS = [
  { id: 'unidades',         etiqueta: '🎓 Unidades del Currículo' },
  { id: 'retos',            etiqueta: '🧩 Retos Diarios' },
  { id: 'racha',            etiqueta: '🔥 Racha de Días' },
  { id: 'juegos',           etiqueta: '🎮 EduNova Juegos' },
  { id: 'clases_grupales',  etiqueta: '👥 Clases Grupales' },
  { id: 'clases_privadas',  etiqueta: '🤝 Clases Privadas' }
]

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
function formatearFecha(fechaIso) {
  if (!fechaIso) return ''
  const f = new Date(fechaIso)
  return `${f.getDate()} de ${MESES[f.getMonth()]} de ${f.getFullYear()}`
}

function TarjetaInsignia({ ins }) {
  const obtenida = ins.obtenida
  return (
    <div style={{
      background: obtenida ? 'linear-gradient(135deg,#FFFBEB,#fff)' : '#F8F9FC',
      border: '1.5px solid ' + (obtenida ? '#F59E0B' : 'var(--gris-borde)'),
      borderRadius: 16, padding: 18, position: 'relative', overflow: 'hidden'
    }}>
      {obtenida && (
        <span style={{ position: 'absolute', top: 10, right: 12, fontSize: 11, fontWeight: 800, color: '#92400E', background: '#FEF3C7', padding: '2px 9px', borderRadius: 999 }}>
          ✓ Obtenida
        </span>
      )}
      <div style={{ fontSize: 38, marginBottom: 8, filter: obtenida ? 'none' : 'grayscale(1) opacity(0.45)' }}>{ins.icono}</div>
      <h3 style={{ fontSize: 15, fontWeight: 800, color: obtenida ? '#92400E' : 'var(--negro)', marginBottom: 4 }}>{ins.nombre}</h3>
      <p style={{ fontSize: 12.5, color: 'var(--gris-texto)', lineHeight: 1.4, marginBottom: 10, minHeight: 34 }}>{ins.descripcion}</p>

      {obtenida ? (
        <p style={{ fontSize: 11, color: '#B45309', fontWeight: 700 }}>Obtenida el {formatearFecha(ins.obtenida_en)}</p>
      ) : (
        <div>
          <div style={{ background: '#E5E7EB', borderRadius: 999, height: 7, overflow: 'hidden', marginBottom: 5 }}>
            <div style={{
              width: `${Math.min(100, Math.round((ins.progreso_actual / ins.meta) * 100))}%`,
              background: 'var(--azul)', height: '100%', borderRadius: 999
            }} />
          </div>
          <p style={{ fontSize: 11, color: 'var(--gris-texto)', fontWeight: 600 }}>{ins.progreso_actual} / {ins.meta}</p>
        </div>
      )}
    </div>
  )
}

/* Pagina de "Insignias": catalogo de logros por categoria (unidades
   completadas, retos diarios, racha, partidas jugadas, clases
   grupales y clases privadas). El backend calcula el progreso y
   otorga automaticamente cualquier insignia nueva al cargar. */
export default function Insignias({ usuario }) {
  const [cargando, setCargando] = useState(true)
  const [datos,    setDatos]    = useState([])
  const [error,    setError]    = useState(null)
  const [nuevas,   setNuevas]   = useState([])

  useEffect(() => {
    if (!usuario?.id) { setCargando(false); return }
    setCargando(true)
    axios.get(`${API}/insignias/${usuario.id}`).then(res => {
      const lista = res.data.datos || []
      setDatos(lista)
      const idsNuevas = res.data.nuevas_desbloqueadas || []
      if (idsNuevas.length) {
        setNuevas(lista.filter(i => idsNuevas.includes(i.id)))
      }
    }).catch(err => {
      console.error('Error cargando insignias:', err)
      setError('No pudimos cargar tus insignias. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [usuario])

  if (cargando) return <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--gris-texto)' }}>Cargando tus insignias...</div>
  if (error) return <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13 }}>{error}</div>

  const totalObtenidas = datos.filter(d => d.obtenida).length

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 1040 }}>
      <div style={{ background: 'linear-gradient(135deg,#92400E,#F59E0B)', borderRadius: 18, padding: '28px 30px', color: '#fff', marginBottom: 22 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ fontSize: 40 }}>🏅</span>
          <div>
            <h1 style={{ fontSize: 24, fontWeight: 800 }}>Insignias</h1>
            <p style={{ fontSize: 14, opacity: .9, marginTop: 4 }}>
              Has desbloqueado <strong>{totalObtenidas}</strong> de <strong>{datos.length}</strong> insignias.
            </p>
          </div>
        </div>
      </div>

      {nuevas.length > 0 && (
        <div style={{ background: '#FEF3C7', border: '1.5px solid #F59E0B', borderRadius: 14, padding: '14px 18px', marginBottom: 24 }}>
          <p style={{ fontSize: 13.5, fontWeight: 800, color: '#92400E', marginBottom: 4 }}>🎉 ¡Nuevas insignias desbloqueadas!</p>
          <p style={{ fontSize: 13, color: '#92400E' }}>
            {nuevas.map(n => `${n.icono} ${n.nombre}`).join('   ·   ')}
          </p>
        </div>
      )}

      {CATEGORIAS.map(cat => {
        const items = datos.filter(d => d.categoria === cat.id)
        if (!items.length) return null
        return (
          <div key={cat.id} style={{ marginBottom: 30 }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 14 }}>{cat.etiqueta}</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 14 }}>
              {items.map(ins => <TarjetaInsignia key={ins.id} ins={ins} />)}
            </div>
          </div>
        )
      })}
    </div>
  )
}
